/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-12 15:09:13
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-14 12:28:35
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/Images/index.tsx
 */
import React from 'react';
import Image from '../../Components/Image/Image1';
import { useDispatch, useSelector } from 'react-redux';
import { onImageChange, getThumbnailImage, EnumCollapseId } from '../slice';
import { useSingleImageEffect } from '@/src/components/Upload';
import { StyledTitle } from 'src/layout/EditorPageLayout/SectionTitle';
import SectionHOC from '../HOC';
import { getI18nFromGeneral } from '@/src/tools/tools';

const ImageSection = (props) => {
  const thumbnailImage = useSelector(getThumbnailImage());

  const [fileList, setFileList] = React.useState(
    thumbnailImage ? [thumbnailImage] : [],
  );
  useSingleImageEffect(thumbnailImage, fileList, setFileList);

  const dispatch = useDispatch();
  const onChange = (img) => {
    dispatch(onImageChange(img));
  };
  return (
    <Image
      disabled={props.disabled}
      onChange={onChange}
      fileList={fileList}
      setFileList={setFileList}
    />
  );
};
export default SectionHOC(ImageSection, {
  id: EnumCollapseId.ThumbnailImage,
  title: (
    <StyledTitle
      left={getI18nFromGeneral('general.hOCTitle.thumbnailImage')}
      leftBottom={getI18nFromGeneral('general.hOCTitle.thumbnailImageBottom')}
    />
  ),

  useCustomCollapseTitle: true,
  useDefaultCollapseContent: true,
});
